import { IndicatorType } from '../constants/common'
import Indicator from './indicator'

interface Attrs {
  period: string
}

class AroonOscillator extends Indicator<Attrs> {
  static type = IndicatorType.Aroosc
  static label = 'Aroon Oscillator'

  oscillator: number[] = []
  declare period: number

  set(values: Partial<Attrs>) {
    super.set(values)
    this.parsePeriodInt(values)
  }

  compute() {
    if (this.isComputeNecessary()) {
      this.oscillator = []

      const startAt = this.period - 1
      for (let i = startAt; i < this.data.close.length; i++) {
        const highPeriod = this.data.high.slice(i - startAt, i + 1)
        const highestInPeriod = Math.max(...highPeriod)
        const periodSinceHigh = this.period - highPeriod.indexOf(highestInPeriod)
        const aroonUp = 100 * ((this.period - periodSinceHigh) / this.period)

        const lowPeriod = this.data.low.slice(i - startAt, i + 1)
        const lowestInPeriod = Math.min(...lowPeriod)
        const periodSinceLow = this.period - lowPeriod.indexOf(lowestInPeriod)
        const aroonDown = 100 * ((this.period - periodSinceLow) / this.period)

        this.oscillator[i] = aroonUp - aroonDown
      }

      this.lastValue = this.oscillator.last() ?? null
    }

    const { min, max } = this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    this.renderOversoldOverbought(context, this.oscillator, this.period, 0, 0, 0, false)
  }

  getModalConfig() {
    const period = {
      type: 'number',
      label: 'Period',
      name: 'period',
      value: this.period ?? 25,
      required: true,
      min: 1,
      max: 999999,
    }

    return {
      title: this.label,
      inputs: [period],
      inputsErrorMessages: {
        period: `${period.label} must be a whole number between ${period.min} and ${period.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }

  toString() {
    return `Aroon Oscillator ${this.period}`
  }
}

export default AroonOscillator
